import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { TCity } from "../types";

// interface ISetEmail {
//   setIsEmailing: boolean;
// }
type TInput = {
  city: TCity;
  toggleValue: boolean;
};
type TOutput = any;

export default class SubscribeEmailingTobBoard extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;
  resolveUri({ city, toggleValue }: TInput): string {
    return `/fe-api/top-board/emailing?villageName=${city}&setIsEmailing=${toggleValue}`;
  }
}
